import React, { Component } from 'react'
import './Jornada.css'
import { database, ref, get } from '../../firebase'
import Loading from '../commons/Loading'
import moment from 'moment'

class Jornada extends Component {
  constructor (props) {
    super(props)
    this.state = {
      partidos: [],
      resultados: [],
      data: {},
      loaded: false
    }
  }
  componentDidMount () {
    this.setState({
      loaded: false
    })
    let partidos, resultados, data
    this.getPartidos(this.props.id)
      .then((results) => {
        partidos = results
        return this.getResultados(this.props.groupId, this.props.id)
      })
      .then((results) => {
        resultados = results
        return this.getData(this.props.groupId, this.props.id)
      })
      .then((res) => {
        data = res
        return this.setRows(partidos, resultados, res)
      })
      .then((rows) => {
        this.setState({
          partidos: partidos,
          resultados: rows,
          data: data,
          loaded: true
        })
      })
      .catch((err) => console.error(err))
  }
  getPartidos (jornadaId) {
    return new Promise((resolve, reject) => {
      get(ref(database, 'quinielas/resultados/' + this.props.mode + '/' + jornadaId))
        .then((snap) => {
          resolve(snap.val())
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
  getResultados (groupId, jornadaId) {
    return new Promise((resolve, reject) => {
      const results = {}
      const promises = []
      let count = 0
      this.props.members.forEach((member) => {
        promises[count] = new Promise((resolve, reject) => {
          get(ref(database, 'grupos/resultados/' + groupId + '/' + jornadaId + '/' + member.id))
            .then((snap) => {
              results[member.id] = snap.val() || []
              resolve()
            })
            .catch((err) => {
              reject(err)
            })
        })
        count++
      })
      Promise.all(promises)
        .then(() => {
          resolve(results)
        })
        .catch((err) => reject(err))
    })
  }
  getData (groupId, jornadaId) {
    return new Promise((resolve, reject) => {
      const data = []
      const promises = []
      let count = 0
      this.props.members.forEach((member) => {
        promises[count] = new Promise((resolve, reject) => {
          let score = 0
          let lastModified = null
          get(ref(database, 'grupos/puntaje/' + groupId + '/quiniela/' + jornadaId + '/' + member.id))
            .then((snap) => {
              if (snap.val()) {
                score = snap.val()
              }
              return get(ref(database, 'grupos/log/' + groupId + '/' + jornadaId + '/' + member.id))
            })
            .then((snap) => {
              if (snap.val()) {
                lastModified = snap.val()
              }
              data.push({
                id: member.id,
                name: member.name,
                photo: member.photo,
                score: score,
                lastModified: lastModified
              })
              resolve()
            })
            .catch((err) => {
              reject(err)
            })
        })
        count++
      })
      Promise.all(promises)
        .then(() => {
          data.sort((a, b) => {
            if (a.score > b.score) {
              return -1
            }
            if (a.score < b.score) {
              return 1
            }
            if (a.lastModified > b.lastModified) {
              return 1
            }
            if (a.lastModified < b.lastModified) {
              return -1
            }
            return 0
          })
          resolve(data)
        })
        .catch((err) => reject(err))
    })
  }
  setRows (partidos, resultados, data) {
    return new Promise((resolve, reject) => {
      const rows = []
      data.forEach((member) => {
        const rowMember = []
        const memberResults = resultados[member.id]
        partidos.forEach((partido, i) => {
          const result = partido.gLocal > partido.gVisitante ? 'l' : partido.gLocal < partido.gVisitante ? 'v' : partido.gLocal === partido.gVisitante && partido.gLocal !== '' ? 'e' : null
          const memberResult = memberResults[i]
          let resultStatus
          if (result) {
            if (memberResult) {
              if (memberResult === result) {
                resultStatus = 'win'
              } else {
                resultStatus = 'lose'
              }
            } else {
              resultStatus = null
            }
          } else {
            resultStatus = null
          }
          rowMember.push({
            status: resultStatus,
            result: memberResult
          })
        })
        rows.push(rowMember)
      })
      resolve(rows)
    })
  }
  render () {
    if (this.state.loaded) {
      return (
        <div className='jornada'>
          <div className='jornada__header'>
            <div className='jornada__labels'>
              <div>Hora</div>
              <div>Pts</div>
            </div>
            <div className='jornada__members'>
              {this.state.data.map((data) => <Member {...data} key={data.id} />)}
            </div>
          </div>
          <div className='jornada__results'>
            <div className='jornada__results__header'>
              {this.state.partidos.map((partido) => <Partido {...partido} key={partido.localId} />)}
            </div>
            <div className='jornada__results__content'>
              {this.state.resultados.map((res, i) => <MemberResults results={res} key={i} />)}
            </div>
          </div>
        </div>
      )
    }
    return (
      <div className='jornada'>
        <div className='jornada__loading'>
          <Loading />
        </div>
      </div>
    )
  }
}

const Member = (props) => (
  <div className='jornada__member'>
    <div className='jornada__member__image'>
      <img src={props.photo} alt={props.name} />
    </div>
    <div className='jornada__member__name'>{props.name.substring(0, 7) + '...'}</div>
    <div className='jornada__member__sended'>{props.lastModified ? moment(props.lastModified).format('D/MM/YY HH:mm:ss') : <div>--<br />--</div>}</div>
    <div className='jornada__member__score'>{props.score || 0}</div>
  </div>
)

const MemberResults = (props) => (
  <div className='jornada__results__col'>
    {props.results.map((res, i) => <div
      className={res.status === 'win' ? 'jornada__results__member_result jornada__results__member_result--win' : res.status === 'lose' ? 'jornada__results__member_result jornada__results__member_result--lose' : 'jornada__results__member_result'}
      key={i}><span>{res.result}</span></div>)}
  </div>
)

const Partido = (props) => (
  <div className='jornada__results__game'>
    <div>{props.local.substring(0, 3) + ' ' + props.gLocal}</div>
    <div>{props.visitante.substring(0, 3) + ' ' + props.gVisitante}</div>
  </div>
)

export default Jornada
